import { TextField, useTheme } from "@mui/material";

export function LabeledText(props: {
  label: string;
  value?: string | undefined | null;
}) {
  const { label, value } = props;
  const theme = useTheme();
  
  return (
    <TextField
      fullWidth
      label={label}
      value={value ?? " "}
      variant="standard"
      size="small"
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          color: theme.palette.text.primary,
          WebkitTextFillColor: theme.palette.text.primary,
          "&::before, &::after": {
            borderBottom: "none !important",
          },
          "&:hover::before": {
            borderBottom: "none !important",
          },
        },
        "& .MuiInputLabel-root.Mui-disabled": {
          color: theme.palette.text.secondary,
          WebkitTextFillColor: theme.palette.text.secondary,
        },
        "& .MuiInput-underline:before, & .MuiInput-underline:after": {
          borderBottom: "none !important",
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "none !important",
        },
      }}
      disabled
    />
  );
}
